// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BQ8FL","header":"styles_header__JOa8T","close":"styles_close__15Eiv","body":"styles_body__Nqq7P","row":"styles_row__0RKJk"};